import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-add-field',
  templateUrl: './modal-add-field.component.html',
  styleUrls: ['./modal-add-field.component.scss']
})
export class ModalAddFieldComponent implements OnInit {
  
  formFields!: FormGroup;
  types= [
    {name: 'New York', code: 'NY'},
    {name: 'Rome', code: 'RM'},
    {name: 'London', code: 'LDN'},
    {name: 'Istanbul', code: 'IST'},
    {name: 'Paris', code: 'PRS'}
  ];
  selectedTypes=[]

  constructor(
		public dialogRef: MatDialogRef<ModalAddFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any
  ) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
		this.dialogRef.close({name:"1234"});
	}
}
